var React = require('react');

var CustomStylesMixin = require('./../custom_styles_mixin');
var RevealMixin = require('../reveal_mixin');

var createReactClass = require('create-react-class');
module.exports = createReactClass({

  displayName: 'Background404',

  mixins : [CustomStylesMixin, RevealMixin],

  render : function () {
    return (
      <div className="content-container" style={this.shadow()}>
        <div className="head-line secondary-text" style={this.secondary_text_color()}>
          404
        </div>
        <div className="subheader" style={this.primary_text_color()}>
          Oops, the page you're
          <br/>
          looking for does not exist.
        </div>
        <div className="hr"></div>
        <div className="clearfix"></div>
        <div className="context" style={this.secondary_text_color()}>
          You may want to head back to the homepage. If you think something is broken, report a problem.
        </div>
        <div className="buttons-container">
          <a href={this.href(this.props.homepage_url)} style={this.button()} target="_blank">
            <span className="fa fa-home"></span>
            Go To Homepage
          </a>
          <a href={this.support_email_address()} style={this.button()} target="_blank">
            <span className="fa fa-warning"></span>
            Report A Problem
          </a>
        </div>
      </div>
    )
  }
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/templates/background/404.jsx